module.exports = __webpack_public_path__ + "static/series_650-a92edd7cc32ba4546d279d00de2e3cc7.png";